import React, { useState, useEffect } from "react";
import styles from "./LocationCard.module.scss";

const LocationCard = ({ location }) => {
  const [iframeUrl, setIframeUrl] = useState("");
  const [mapUrl, setMapUrl] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const generateSearchQuery = () => {
    let query = "";

    if (location.branchName) {
      query = location.branchName;
    } else if (location.address) {
      query = location.address;
    } else {
      query = "Автошкола";
    }

    return encodeURIComponent(query);
  };

  const generateIframeUrl = () => {
    const query = generateSearchQuery();

    let coordinates = "37.617,55.755";

    const address = location.address || location.branchName || "";
    const addressLower = address.toLowerCase();

    if (addressLower.includes("реутов")) {
      coordinates = "37.858,55.758";
    } else if (addressLower.includes("балашиха")) {
      coordinates = "37.957,55.797";
    } else if (addressLower.includes("жуковский")) {
      coordinates = "38.120,55.595";
    }

    const params = new URLSearchParams({
      mode: "search",
      text: query,
      z: "16",
      ll: coordinates,
    });

    return `https://yandex.ru/map-widget/v1/?${params.toString()}`;
  };

  const generateMapUrl = () => {
    const query = generateSearchQuery();

    if (location.mapUrl && location.mapUrl.startsWith("http")) {
      return location.mapUrl;
    }

    return `https://yandex.ru/maps/?text=${query}&mode=search`;
  };

  const loadMap = () => {
    try {
      setLoading(true);

      if (
        location.yandexFrameUrl &&
        location.yandexFrameUrl.startsWith("http")
      ) {
        setIframeUrl(location.yandexFrameUrl);
      } else {
        setIframeUrl(generateIframeUrl());
      }

      const generatedMapUrl = generateMapUrl();
      setMapUrl(generatedMapUrl);

      setError(null);
    } catch (err) {
      setError("Не удалось загрузить карту");

      try {
        const query = encodeURIComponent(location.address || "Автошкола");
        setMapUrl(`https://yandex.ru/maps/?text=${query}`);
        setIframeUrl(
          `https://yandex.ru/map-widget/v1/?mode=search&text=${query}`
        );
      } catch (fallbackErr) {
        console.error("Ошибка генерации карты:", fallbackErr);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (location && location.address) {
      loadMap();
    } else {
      setError("Адрес не указан");
      setLoading(false);
    }
  }, [location]);

  const formatAddress = () => {
    if (!location.address || location.address === "Адрес не указан") {
      return "Адрес не указан";
    }

    return location.address;
  };

  if (!location || !location.address) {
    return (
      <div className={styles.locationCard}>
        <div className={styles.locationCard__empty}>
          <div className={styles.locationCard__emptyIcon}>📍</div>
          <div className={styles.locationCard__emptyText}>
            Нет данных об адресе
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.locationCard}>
      <a
        href={mapUrl}
        className={styles.locationCard__mapLink}
        target="_blank"
        rel="noopener noreferrer"
        title={`Открыть "${location.address}" в Яндекс Картах`}
        aria-label={`Открыть адрес "${location.address}" в Яндекс Картах`}
      >
        {loading ? (
          <div className={styles.locationCard__message}>
            <div className={styles.locationCard__spinner}></div>
            <div>Загрузка карты...</div>
          </div>
        ) : error ? (
          <div className={styles.locationCard__message}>
            <div className={styles.locationCard__errorIcon}>⚠️</div>
            <div>{error}</div>
          </div>
        ) : (
          <iframe
            src={iframeUrl}
            className={styles.locationCard__map}
            loading="lazy"
            frameBorder="0"
            allowFullScreen
            title={`Карта: ${location.address}`}
            aria-label={`Интерактивная карта: ${location.address}`}
          />
        )}
        <div className={styles.locationCard__overlay}>
          <span className={styles.locationCard__overlayText}>
            Открыть в Яндекс Картах
          </span>
        </div>
      </a>
      <div className={styles.locationCard__address}>{formatAddress()}</div>
    </div>
  );
};

export default LocationCard;
